import { Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, } from '@ng-bootstrap/ng-bootstrap';
import { Organisation } from 'src/app/models/organisation';
import { User } from 'src/app/models/user';
import { WhiteLabel } from 'src/app/models/whiteLabel';

@Component({
  templateUrl: './edit-whitelabel.modal.html',
})
export class EditWhiteLabelModal implements OnInit {
  private _whiteLabelProvider: WhiteLabel = new WhiteLabel;
  @Input('whiteLabelProvider') set whiteLabelProvider(val:WhiteLabel) {
    this._whiteLabelProvider = val;
    this.newWhiteLabelProvider = false;
    if(val.whiteLabel != null && val.whiteLabel != undefined) {
      this.whiteLabelProviderName = val.whiteLabel.name;
      this.whitelabelProviderId = val.whiteLabel.id;    
      this.accountLicenses = val.whiteLabel.maxUserCount;
      this.organisations = val.whiteLabel.maxOrganisationCount;
    }
  }
  get whiteLabelProvider(): WhiteLabel {
    return this._whiteLabelProvider;
  }
  @Input('whitelabelProviders') whitelabelProviders: any[] = [];
  @Input('user') user!: User;
  @Output('updateWhiteLabelProvider') updateWhiteLabelProvider: EventEmitter<any> = new EventEmitter<any>();

  whitelabelProviderId!: number;
  newWhiteLabelProvider: boolean = true;
  whiteLabelProviderName: string = "";
  organisations: number | null = 0;
  accountLicenses: number | null = 0;
  form: UntypedFormGroup;

  constructor(private formBuilder: UntypedFormBuilder, private activeModal: NgbActiveModal) {
    this.form = this.formBuilder.group(
      {
        organisationName: new UntypedFormControl(''),
        accountLicenses: new UntypedFormControl('')
      }
    );
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  save() {
    let organisationName = (document.getElementById('WhiteLabelProviderName') as HTMLInputElement).value;
    let organisations = (document.getElementById('Organisations') as HTMLInputElement).value;
    let accountLicenses = (document.getElementById('AccountLicenses') as HTMLInputElement).value;
    if(this.whiteLabelProvider.whiteLabel === null || this.whiteLabelProvider.whiteLabel === undefined) {
      this.whiteLabelProvider.whiteLabel = {};
    } 
    this.whiteLabelProvider.whiteLabel.Name = organisationName;
    this.whiteLabelProvider.whiteLabel.MaxUserCount = accountLicenses;
    this.whiteLabelProvider.whiteLabel.MaxOrganisationCount = organisations;
    
    this.updateWhiteLabelProvider.emit(this.whiteLabelProvider.whiteLabel);
  }

  close() {
    this.activeModal.close();
  }

}
